// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { messageBoxHandler } from '@shared/utils/AppHandlers';
import PositionSizeButtonTemplate from '@front/templates/PositionSizeButtonTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { LOCALE_EN, Resources } from '@shared/localizations/Resources';
import { AccountType } from '@shared/utils/cache/Accounts/Account.types';
import { RulesSet } from '@shared/utils/Rules/RulesSet';
import { IsAllowed } from '@shared/commons/IsAllowed';
import { ConfirmationTypesEnum } from '@shared/utils/Trading/ConfirmationTypesEnum';
import { DataCache } from '@shared/commons/DataCache';
import { WDSettingsUtils } from '../../UtilsClasses/WDGeneralSettingsUtils';
import { WDSettings } from '../../settings/WDGeneralSettings';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class PositionSizeButton extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'PositionSizeButton';
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        DataCache.OnTradingSessionStatusUpdated.Subscribe(this.updateEnability, this);
        WDSettings.settingsChanged.Subscribe(this.updateEnability, this);
        this.observe('account instrument', this.updateEnability);
        this.localize();
    }
    onClick(event) {
        var _a;
        (_a = event === null || event === void 0 ? void 0 : event.original) === null || _a === void 0 ? void 0 : _a.stopPropagation(); /* #129600 */
        if (!this.get('positionSizingEnabled')) {
            return;
        }
        const checked = this.get('checked');
        const newCheckedState = !checked;
        void this.set('checked', newCheckedState);
        const confirmationType = ConfirmationTypesEnum.PositionSizeCalculatorInfoWindow;
        if (newCheckedState && WDSettingsUtils.useConfirmation(confirmationType)) {
            const OkCb = (showNextTime) => {
                WDSettingsUtils.updateConfirmation(confirmationType, showNextTime);
            };
            let infoText = Resources.getResource('positionSizeCalculator.infoText');
            if (!Resources.isHidden('positionSizeCalculator.helpLink')) {
                const linkTxt = Resources.getResource('positionSizeCalculator.infoText.linkPart');
                const linkUrl = Resources.getResourceLang('positionSizeCalculator.helpLink', LOCALE_EN);
                const linkPartSplitted = linkTxt.split('{0}');
                infoText +=
                    ' ' +
                        (linkPartSplitted[0] ? linkPartSplitted[0] : '') +
                        // '<div class="link-container-in-pos-sizing-info">' + (linkPartSplitted[0] ? linkPartSplitted[0] : '') +  // https://tp.traderevolution.com/entity/107977 не удалял насовсем вариант с переносом на новую строку ибо он мне нравится больше, пускай хоть комментарием останется :)
                        '<a target="_blank" class="link-in-pos-sizing-info" rel="noopener noreferrer" href="' +
                        linkUrl +
                        '">' +
                        (linkPartSplitted[1] ? linkPartSplitted[1] : '') +
                        '</a>' +
                        (linkPartSplitted[2] ? linkPartSplitted[2] : '');
                // + '</div>'
            }
            messageBoxHandler.Show(Resources.getResource('positionSizeCalculator.header'), infoText, messageBoxHandler.msgType.Info, OkCb, null, true, true, null);
        }
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        DataCache.OnTradingSessionStatusUpdated.UnSubscribe(this.updateEnability, this);
        WDSettings.settingsChanged.UnSubscribe(this.updateEnability, this);
        super.dispose();
    }
    localize() {
        const tooltipLocKey = this.isAllowedToUse()
            ? 'positionSizeCalculator.button.tt'
            : 'positionSizeCalculator.buttonDisabled.tt';
        void this.set('tooltip', Resources.getResource(tooltipLocKey));
    }
    updateEnability() {
        const enabled = this.isAllowedToUse();
        void this.set('positionSizingEnabled', enabled);
        if (!enabled) {
            void this.set('checked', false);
        }
        this.localize();
    }
    isAllowedToUse() {
        const acc = this.get('account');
        if (isNullOrUndefined(acc))
            return false;
        let isSLAllowed = DataCache.isAllowedForAccount(RulesSet.FUNCTION_SLTP, acc) &&
            IsAllowed.IsSLTPAllowed(this.get('instrument'), acc, true).Allowed;
        if (acc.AccountType === AccountType.MultiAsset) {
            isSLAllowed = false;
        }
        return isSLAllowed;
    }
}
ContainerControl.extendWith(PositionSizeButton, {
    template: PositionSizeButtonTemplate,
    data: function () {
        return {
            checked: false,
            instrument: null,
            account: null,
            positionSizingEnabled: true
        };
    }
});
